<!-- 模拟考试 -->
<template>
  <div class="practiceTest" v-loading="allLoading">
    <div v-if="visiType == 1 || isModify">
      <div class="examInfo">
        <el-row style="margin-bottom: 20px">
          <el-col :span="3">
            考试科目：{{ examInfo.subjectName }}
          </el-col>
          <el-col :span="3">
            级别：{{ examInfo.subjectLevelName }}
          </el-col>
          <el-col :span="6">
            是否禁止抽中为考题：
            <el-radio-group v-model="zt" @change="changeZt">
              <el-radio label="0">否</el-radio>
              <el-radio label="1">是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="8">
            <el-date-picker :disabled="zt == '0'" v-model="times" value-format="yyyy-MM-dd" type="daterange"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-col>
          <el-col :span="2">
            <el-button @click="save" type="primary">保存</el-button>
          </el-col>
        </el-row>
        <el-row style="margin-bottom: 30px">
          <el-col :span="2">
            归属部分：
          </el-col>
          <el-col :span="3" v-for="(type, index) in selectType" :key="index + 'a'">
            <el-radio @change="getLibrey" v-model="typeList" :label="type.value">{{ type.label
            }}({{ type.num }})</el-radio>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2">
            题型：
          </el-col>
          <el-col :span="3" v-for="(tx, index) in selectTx" :key="index">
            <el-radio @change="getLibrey" v-model="txList" :label="tx.value">{{ tx.label }}({{ tx.num }})</el-radio>
          </el-col>
        </el-row>
      </div>
      <div class="setExam">
        <div class="allTest" v-loading="loading">
          <p class="examTitle">全部试题</p>
          <template v-for="(item, index) in testList">
            <div class="testInfo" :key="index" v-if="simuList.findIndex(opt => {
              return opt.id == item.id
            }) == -1">
              <div class="testTitle">
                <p style="display: flex;justify-content: space-between;width: 83%;">（{{ item.txName }}）{{ item.name }}
                  <span v-if="item.tx == 3">正确答案:{{ item.answer
                  }}</span>
                </p>
                <el-button type="primary" :disabled="simuList.findIndex(opt => {
                    return opt.id == item.id
                  }) != -1" @click="addSimu(item)" style="width: 15%;">添加至试卷</el-button>
              </div>
              <template v-if="item.nameUrl != null && item.nameUrl.length > 0">
                <template v-for="(file, sum) in item.nameUrl">
                  <div class="autioDiv" style="height:100%" :key="sum + 'file'" v-if="$expForMat(file.fileName)">
                    <autioCate :name="false" :proSty="true" width="100%" height="50px" :audioSrc="file" />
                  </div>
                  <img v-else :src="file.url" style="height: 80px;max-width: 90%;">
                </template>
              </template>
              <div v-for="( option, i ) in  item.options " :key="i" class="option">
                <p class="optTitle" v-if="item.tx == 1">
                  <el-radio v-model="item.answer" :label="option.num" :disabled="true">
                    <i></i>
                  </el-radio> {{ option.num }}.{{ option.content }}
                </p>
                <p class="optTitle" v-if="item.tx == 2 || item.tx == 3">
                  <el-checkbox v-model="item.answer.split(',')" :label="option.num" :disabled="true">
                    <i></i>
                  </el-checkbox> {{ option.num }}.{{ option.content }}
                </p>
                <template v-if="option.fj && option.fj.url">
                  <div class="autioDiv" style="height:100%"
                    v-if="option.fj.fileName.split('.')[option.fj.fileName.split('.').length - 1] == 'mp3' || option.fj.fileName.split('.')[option.fj.fileName.split('.').length - 1] == 'MP3'">
                    <autioCate :name="false" :proSty="true" width="100%" height="50px" :audioSrc="option.fj" />
                  </div>
                  <div class="optImgDiv" v-else style="height: 80px;max-width: 90%;">
                    <img :src="option.fj.url">
                  </div>
                </template>
              </div>
            </div>
          </template>
        </div>
        <div class="allTest">
          <p class="examTitle">模拟试卷</p>
          <div class="testInfo" v-for="( item, index ) in  simuList " :key="index">
            <div class="testTitle">
              <p style="display: flex;justify-content: space-between;width: 83%;">（{{ item.txName }}）{{ item.name }} <span
                  v-if="item.tx == 3">正确答案:{{ item.answer
                  }}</span></p>
              <el-button type="danger" plain @click="deleteSimu(item)" style="width: 15%;">移除该试题</el-button>
            </div>
            <template v-if="item.nameUrl != null && item.nameUrl.length > 0">
              <template v-for="(file, sum) in item.nameUrl">
                <div class="autioDiv" style="height:100%" :key="sum + 'file'" v-if="$expForMat(file.fileName)">
                  <autioCate :name="false" :proSty="true" width="100%" height="50px" :audioSrc="file" />
                </div>
                <img v-else :src="file.url" style="height: 80px;max-width: 90%;">
              </template>
            </template>
            <div v-for="( option, i ) in  item.options " :key="i" class="option">
              <p class="optTitle" v-if="item.tx == 1">
                <el-radio v-model="item.answer" :label="option.num" :disabled="true">
                  <i></i>
                </el-radio> {{ option.num }}.{{ option.content }}
              </p>
              <p class="optTitle" v-if="item.tx == 2 || item.tx == 3">
                <el-checkbox v-model="item.answer.split(',')" :label="option.num" :disabled="true">
                  <i></i>
                </el-checkbox> {{ option.num }}.{{ option.content }}
              </p>
              <template v-if="option.fj && option.fj.url">
                <div class="autioDiv" style="height:100%"
                  v-if="option.fj.fileName.split('.')[option.fj.fileName.split('.').length - 1] == 'mp3' || option.fj.fileName.split('.')[option.fj.fileName.split('.').length - 1] == 'MP3'">
                  <autioCate :name="false" :proSty="true" width="100%" height="50px" :audioSrc="option.fj" />
                </div>
                <div class="optImgDiv" v-else style="height: 80px;max-width: 90%;">
                  <img :src="option.fj.url">
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="examInfo" style="background: #fff;height:50px;">
        <el-row style="margin-bottom: 20px" v-if="testDetail[0]">
          <el-col :span="5">
            考试科目：{{ examInfo.subjectName }}
          </el-col>
          <el-col :span="5">
            级别：{{ examInfo.subjectLevelName }}
          </el-col>
          <el-col :span="6">
            是否禁止抽中为考题：
            {{ testDetail[0].zt == '0' ? '否' : '是' }}
          </el-col>
          <el-col :span="5" v-if="testDetail[0].zt == '1'">
            {{ testDetail[0].startTime }} 至 {{ testDetail[0].endTime }}
          </el-col>
          <el-button v-if="alter" class="amendBtn" @click="amend" type="primary">修改</el-button>
        </el-row>
      </div>
      <div class="testList">
        <div class="testItem" v-for="( test, index ) in  testDetail " :key="index">
          <div class="testTitle">
            <p style="display: flex;justify-content: space-between;width: 83%;">（{{ test.txName }}）{{ test.name }} <span
                v-if="test.tx == 3">正确答案:{{ test.answer
                }}</span></p>
          </div>
          <template v-if="test.nameUrl != null && test.nameUrl.length > 0">
            <template v-for="(file, sum) in test.nameUrl">
              <div class="autioDiv" style="height:100%" :key="sum + 'file'" v-if="$expForMat(file.fileName)">
                <autioCate :name="false" :proSty="true" width="60%" height="50px" :audioSrc="file" />
              </div>
              <img v-else :src="file.url" style="height: 80px;max-width: 90%;">
            </template>
          </template>
          <div v-for="( option, i ) in  test.options " :key="i" class="option">
            <p class="optTitle" v-if="test.tx == 1">
              <el-radio v-model="test.answer" :label="option.num" :disabled="true">
                <i></i>
              </el-radio> {{ option.num }}.{{ option.content }}
            </p>
            <p class="optTitle" v-if="test.tx == 2 || test.tx == 3">
              <el-checkbox v-model="test.answer.split(',')" :label="option.num" :disabled="true">
                <i></i>
              </el-checkbox> {{ option.num }}.{{ option.content }}
            </p>
            <template v-if="option.fj && option.fj.url">
              <div class="autioDiv" style="height:100%"
                v-if="option.fj.fileName.split('.')[option.fj.fileName.split('.').length - 1] == 'mp3' || option.fj.fileName.split('.')[option.fj.fileName.split('.').length - 1] == 'MP3'">
                <autioCate :name="false" :proSty="true" width="100%" height="50px" :audioSrc="option.fj" />
              </div>
              <div class="optImgDiv" v-else style="height: 80px;max-width: 90%;">
                <img :src="option.fj.url">
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import autioCate from '../../../components/autioCate.vue'

export default {
  name: 'practiceTest',
  components: { autioCate },
  data() {
    return {
      examInfo: {},
      testList: [],
      radio: 0,
      checked: [],
      value1: '',
      selectTx: [],
      selectType: [],
      txList: "",
      typeList: "",
      query: { tx: '', type: '' },
      loading: false,
      allLoading: false,
      simuList: [],
      zt: "0",
      times: [],
      visiType: 1,
      isModify: false,
      testDetail: [],
      alter: null
    }
  },
  methods: {
    amend() {
      this.simuList = this.testDetail
      this.zt = String(this.testDetail[0].zt)
      if (this.zt == '1') {
        this.times = [this.testDetail[0].startTime, this.testDetail[0].endTime]
      }
      this.simuListNums()
      this.isModify = true
    },
    changeZt() {
      this.times = []
    },
    getTestDetail() {
      this.$axios.get(`/basicQuestionsScore/info/${this.examInfo.ids}`).then((res) => {
        this.testDetail = res.data.data
        this.loading = false
      });
    },
    save() {
      if (this.zt == '1') {
        if (this.times.length == 0) {
          this.$message.error("时间未选择");
          return
        }
      }
      let data = this.simuList.map((item, index) => {
        return { id: item.id, px: index + 1, scoreId: item.scoreId }
      })
      if (data.length == 0) {
        this.$message.error("试卷试题不能为空!");
        return
      }
      let subInfo = {
        data,
        zt: this.zt,
        subjectLevel: this.examInfo.subjectLevel,
        examInformationId: this.examInfo.id,
      }
      if (this.zt == '1') {
        subInfo.startTime = this.times[0]
        subInfo.endTime = this.times[1]
      }
      this.allLoading = true
      let url = ''
      if (this.visiType == 1) {
        url = "/basicQuestionsScore/save"
      } else {
        url = "/basicQuestionsScore/update"
      }
      console.log('提交数据', subInfo);
      this.$axios.post(url, subInfo).then((res) => {
        this.$message.success("模拟试卷已保存!");
        this.$router.push({ path: "/examManag/testGroupPaper" })
        this.allLoading = false
      });
    },
    simuListNums() {
      this.selectTx[0].num = this.selectTx[0].tempId - this.simuList.length
      let num1 = 0
      this.simuList.find(item => {
        if (item.tx == 1) {
          num1++
        }
      })
      this.selectTx[1].num = this.selectTx[1].tempId - num1

      let num2 = 0
      this.simuList.find(item => {
        if (item.tx == 2) {
          num2++
        }
      })
      this.selectTx[2].num = this.selectTx[2].tempId - num2

      let num3 = 0
      this.simuList.find(item => {
        if (item.tx == 3) {
          num3++
        }
      })
      this.selectTx[3].num = this.selectTx[3].tempId - num3

      let num4 = 0
      this.simuList.find(item => {
        if (item.tx == 4) {
          num4++
        }
      })
      this.selectTx[4].num = this.selectTx[4].tempId - num4

      this.selectType[0].num = this.selectType[0].tempId - this.simuList.length
      let typ1 = 0
      this.simuList.find(item => {
        if (item.type == 1) {
          typ1++
        }
      })
      this.selectType[1].num = this.selectType[1].tempId - typ1

      let typ2 = 0
      this.simuList.find(item => {
        if (item.type == 2) {
          typ2++
        }
      })
      this.selectType[2].num = this.selectType[2].tempId - typ2

      let typ3 = 0
      this.simuList.find(item => {
        if (item.type == 3) {
          typ3++
        }
      })
      this.selectType[3].num = this.selectType[3].tempId - typ3

      let typ4 = 0
      this.simuList.find(item => {
        if (item.type == 4) {
          typ4++
        }
      })
      this.selectType[4].num = this.selectType[4].tempId - typ4

      console.log(55, this.selectType);
    },
    addSimu(test) {
      let idx = this.simuList.findIndex(item => {
        return item.id == test.id
      })
      if (idx == -1) {
        this.simuList.push(test)
        this.simuListNums()
        this.$message.success("添加成功!");
        return
      } else {
        this.$message.warning("该题已经添加至模拟试卷!");
        return
      }
    },
    deleteSimu(test) {
      let ind = this.simuList.findIndex(item => {
        return item.id == test.id
      })
      this.simuList.splice(ind, 1)
    },
    getLibrey() {
      this.loading = true
      // 获取试题信息
      this.$axios.get(`/basicQuestionsScore/selectLibrary/${this.examInfo.subjectId}/${this.examInfo.subjectLevel}?tx=${this.txList}&&type=${this.typeList}`).then((res) => {
        this.testList = res.data.data
        this.loading = false
      });
    },
    getInfo() {
      // 获取题型下拉框
      this.$axios.get(`/basicQuestionsScore/selectTx/${this.examInfo.subjectId}/${this.examInfo.subjectLevel}`).then((res) => {
        this.selectTx = res.data.data
        this.selectTx.forEach(item => {
          item.num = item.tempId
        })
      });
      // 获取归属部知识点
      this.$axios.get(`/basicQuestionsScore/selectNodes/${this.examInfo.subjectId}/${this.examInfo.subjectLevel}`).then((res) => {
      });
      // 获取归属部分
      this.$axios.get(`/basicQuestionsScore/selectType/${this.examInfo.subjectId}/${this.examInfo.subjectLevel}`).then((res) => {
        this.selectType = res.data.data
        this.selectType.forEach(item => {
          item.num = item.tempId
        })
      });
      this.getLibrey()
    },
  },
  created() {
    this.examInfo = JSON.parse(this.$route.query.row)
    this.visiType = this.$route.query.visiType
    this.alter = JSON.parse(this.$route.query.alter)
    if (this.visiType == 2) {
      this.getTestDetail()
      this.isModify = false
    }
  },
  mounted() {
    this.getInfo()
  },
}
</script>

<style lang="scss" scoped>
.amendBtn {
  position: absolute;
  right: 0;
}

.optImgDiv {
  width: 100px;
  height: 100px;

  img {
    width: 100%;
    height: 100%;
    margin: auto;
    object-fit: contain;
  }
}

.option {
  margin-bottom: 10px;
  padding-left: 20px;

  .optTitle {
    margin-bottom: 10px;
  }
}

.examInfo {
  width: 100%;
  box-sizing: border-box;
  height: 200px;
  background-color: #f6f6f6;
  margin-bottom: 20px;
  padding: 20px 0 0 180px;
  font-size: 18px;
  font-weight: 600;
}

.setExam {
  width: 100%;
  display: flex;
  justify-content: space-between;

  .examTitle {
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 20px;
  }

  .testInfo {
    background-color: #fff;
    padding: 10px;
    margin-bottom: 20px;


  }

  .allTest {
    width: 45%;
    background-color: #f6f6f6;
    padding: 20px;
  }
}

.testTitle {
  display: flex;
  color: #333;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.testList {
  .testItem {
    width: 80%;
    margin: auto;
    border: 2px dashed #e4e4e4;
    padding: 20px;
    margin-bottom: 20px;
  }
}
</style>